import { onDomReady } from '../helpers/onDomReady';
import { MessageTypes } from '../constants/MessageTypes';
const STYLE_ELEMENT_ID = 'web-interactives-external-style';
export class ContainerExternalStylesController {
  constructor({
    applicationController
  }) {
    this.handleExtractedStyles = ({
      extractedStyles
    }) => {
      let cssString = '';

      // Apply standard CSS rules
      for (const [selector, properties] of Object.entries(extractedStyles.rules)) {
        cssString += `${selector} { `;
        for (const [property, value] of Object.entries(properties)) {
          cssString += `${property}: ${value}; `;
        }
        cssString += `} `;
      }

      // Apply keyframe animations
      for (const [keyframeName, keyframes] of Object.entries(extractedStyles.keyframes)) {
        cssString += `@keyframes ${keyframeName} { `;
        for (const keyframe of keyframes) {
          cssString += `${keyframe.keyText} { `;
          for (const [property, value] of Object.entries(keyframe.style)) {
            cssString += `${property}: ${value}; `;
          }
          cssString += `} `;
        }
        cssString += `} `;
      }
      this.styleElement.innerHTML = cssString;
    };
    this.applicationController = applicationController;
    this.styleElement = document.getElementById(STYLE_ELEMENT_ID) || document.createElement('style');
    this.styleElement.id = STYLE_ELEMENT_ID;
    this.registerExternalStylesHandler();
    onDomReady(() => {
      document.head.appendChild(this.styleElement);
    });
  }
  registerExternalStylesHandler() {
    this.applicationController.registerHandler(MessageTypes.SEND_EXTRACTED_STYLES, this.handleExtractedStyles);
  }
}